import type { ShareButtonProps, SocialShareType } from "@product/scmp-sdk";
import { Modal, ShareButton } from "@product/scmp-sdk";
import { bindMenu, bindTrigger, usePopupState } from "material-ui-popup-state/hooks";
import type { FunctionComponent } from "react";
import { useContext } from "react";

import { Menu } from "~/components/common/menu";
import { MenuItemStyled } from "~/components/common/menu/styles";
import { useArrowModifiers } from "~/components/common/popper/hooks";
import { GalleryContext } from "~/components/image-gallery/contexts";

import { StyledArrowUp } from "./styles";
import { ToolbarButton } from "./toolbar-button";

export type Props = Pick<ShareButtonProps, "relativeUrl" | "shortUrl" | "title" | "utm">;

export const ToolbarButtonShare: FunctionComponent<Props> = ({
  relativeUrl,
  shortUrl,
  title,
  utm,
}) => {
  const { rootPortalElement } = useContext(GalleryContext);

  const popupState = usePopupState({
    popupId: "gallery-share-menu",
    variant: "popper",
  });
  const { arrowModifier, captureArrowElementReference } = useArrowModifiers();

  const renderMenuItems = () => {
    const socialShareTypes: SocialShareType[] = ["facebook", "twitter", "email"];
    return socialShareTypes.map(type => (
      <MenuItemStyled key={type} onClick={popupState.close}>
        <ShareButton
          relativeUrl={relativeUrl}
          shortUrl={shortUrl}
          title={title}
          type={type}
          utm={utm}
          hideIcon
          showLabel
        />
      </MenuItemStyled>
    ));
  };

  return (
    <>
      <span {...bindTrigger(popupState)}>
        <ToolbarButton icon="share" title="Share" />
      </span>
      <Modal container={rootPortalElement} open={popupState.isOpen}>
        <Menu
          {...bindMenu(popupState)}
          slotProps={{
            root: {
              disablePortal: true,
              keepMounted: true,
              modifiers: [arrowModifier],
            },
          }}
        >
          <StyledArrowUp ref={captureArrowElementReference} />
          {renderMenuItems()}
        </Menu>
      </Modal>
    </>
  );
};

ToolbarButtonShare.displayName = "ToolbarButtonShare";
